import { render, staticRenderFns } from "./addDizhiHuozhu.vue?vue&type=template&id=67afc13c&scoped=true&"
import script from "./addDizhiHuozhu.vue?vue&type=script&lang=js&"
export * from "./addDizhiHuozhu.vue?vue&type=script&lang=js&"
import style0 from "./addDizhiHuozhu.vue?vue&type=style&index=0&id=67afc13c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67afc13c",
  null
  
)

export default component.exports